function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "15",
  viewBox: "0 0 16 15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.767 13.433V4.574L2.712 8.426a1.287 1.287 0 01-1.75 0 1.129 1.129 0 010-1.658L7.124.933c.117-.107.255-.19.407-.245.3-.117.636-.117.936 0 .151.055.29.138.407.245l6.161 5.835c.234.22.365.518.365.83 0 .31-.131.609-.365.828a1.268 1.268 0 01-.874.345c-.329 0-.644-.124-.875-.345L9.23 4.574v8.859c0 .644-.551 1.167-1.232 1.167-.68 0-1.232-.523-1.232-1.167z",
  fill: "#FA6446",
  fillRule: "evenodd"
})));